module.exports = __webpack_public_path__ + "img/bg.f91205cd.jpg";